import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetch(`${API}/reviews`).then((r) => r.json()).then((d) => setReviews(d.reviews || [])).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section className="px-6 sm:px-10 lg:px-16 py-24 lg:py-32 bg-[var(--surface)] border-y border-[rgba(201,162,74,0.18)]" data-testid="reviews-section">
      <div className="mx-auto max-w-[1200px]">
        <Reveal>
          <p className="text-[var(--gold)] uppercase tracking-[0.4em] text-xs text-center mb-14">What guests say</p>
        </Reveal>
        <div className="flex flex-wrap justify-center gap-10 lg:gap-14">
          {reviews.map((r, i) => (
            <Reveal key={r.id || i} delay={(i % 3) * 0.12} className="w-full md:w-[calc(33.333%-2.5rem)]">
              <figure className="flex flex-col items-center text-center h-full" data-testid={`review-${i}`}>
                <span className="font-display text-6xl text-[var(--gold)] leading-none select-none" aria-hidden="true">“</span>
                <blockquote className="font-serif-alt italic text-xl sm:text-2xl text-[var(--cream)] leading-relaxed mt-2">
                  {r.text}
                </blockquote>
                <figcaption className="mt-6 font-body uppercase tracking-[0.25em] text-[11px] text-[var(--muted)]">
                  <span className="text-[var(--gold)]">◆</span>&nbsp;&nbsp;{r.name}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
